import React from "react";
import {useSelector} from "../../../shared-services/redux-tiny";
import {FarmyColumn, FarmyColumnSet} from "../../layouts/components/FarmyColumns";
import {Title3} from "../../layouts/components/Titles";
import {t} from "../../../shared-services/translate";
import useWindowTools from "../../../react-hooks/useWindowTools";

import HorizontalScrollProductList from "../product-lists/HorizontalScrollProductList";
import PDPBoughtTogetherList from "../product-lists/PDPBoughtTogetherList";
import CartBoughtTogetherList from "../product-lists/CartBoughtTogetherList";
import CurrentTrendsList from "../product-lists/CurrentTrendsList";

const RecommendationsPDP = (props) => {
  const {product} = props;
  const {currentCart} = useSelector(state => state.cart);
  const {isMobile} = useWindowTools();

  const titleClasses = `
    font-weight-100
    text-color-body-light
    ${isMobile ? "margin-bottom-10" : null}
  `;

  return <>
    <FarmyColumnSet className="margin-top-30">
      <FarmyColumn>
        <Title3 className={titleClasses}>
          {t("product_lists.bought_together.title")}
        </Title3>
        <HorizontalScrollProductList
          ProductList={PDPBoughtTogetherList}
          product={product}
          trackingListName="pdp_recommend.bought_together"
        />
      </FarmyColumn>
    </FarmyColumnSet>

    {currentCart?.line_items?.length > 1 && <FarmyColumnSet className="margin-top-30">
      <FarmyColumn>
        <Title3 className={titleClasses}>
          {t("product_lists.recommended_for_you.title")}
        </Title3>
        <HorizontalScrollProductList
          ProductList={CartBoughtTogetherList}
          excludeIds={[product?.id]}
          trackingListName="pdp_recommend.for_you"
        />
      </FarmyColumn>
    </FarmyColumnSet>}

    <FarmyColumnSet className="margin-top-30">
      <FarmyColumn>
        <Title3 className={titleClasses}>
          {t("product_lists.current_trends.title")}
        </Title3>
        <HorizontalScrollProductList
          ProductList={CurrentTrendsList}
          trackingListName="pdp_recommend.current_trends"
        />
      </FarmyColumn>
    </FarmyColumnSet>
  </>;
};

export default RecommendationsPDP;
